import { HeroWrapper } from "./Hero.styles";

const HeroSection = () => {
  return (
    <HeroWrapper>
      
    </HeroWrapper>
  );
};

export default HeroSection;
